import React, { useEffect, useState } from 'react';

import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';

import css from '../nibTable.module.sass';

function isInvalidDate(d) {
  return isNaN(Date.parse(d));
}

const DateCell = ({ value: initialValue, row: { index }, column: { id }, updateMyData, rowToEdit, data }) => {
  const formateData = (date) => {
    try {
      date = new Date(date);
      let formattedDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0];
      return formattedDate;
    } catch (error) {
      return date;
    }
  };

  const oninit = initialValue === null ? formateData(new Date()) : initialValue;

  const [value, setValue] = useState(new Date(oninit));

  const onBlur = (e) => {
    let val = new Date(e.target.value);
    if (isInvalidDate(val)) {
      updateMyData({ accessor: id, value: oninit });
    } else {
      updateMyData({ accessor: id, value: val });
    }
  };

  const onChange = (e) => {
    try {
      let val = new Date(e.target.value);
      setValue(val);
    } catch (error) {
      console.log(error);
      setValue(e.target.value);
    }
  };

  const generateLabel = () => {
    let label = new Date(formateData(new Date(value)));
    if (isInvalidDate(label)) {
      return '-';
    } else {
      return label.toLocaleDateString();
    }
  };

  if (rowToEdit.index === index && rowToEdit.status && !data.readOnly) {
    return (
      <div className={css.dateCell}>
        <IconButton
          onClick={() => {
            setValue(initialValue);
            updateMyData({ accessor: id, value: initialValue });
          }}
        >
          <CloseIcon style={{ color: '#fff' }} />
        </IconButton>
        <TextField
          id="date"
          type="date"
          variant="outlined"
          size="small"
          value={formateData(new Date(value))}
          onChange={onChange}
          onBlur={onBlur}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </div>
    );
  } else {
    return <p>{!initialValue ? '(not set)' : generateLabel()}</p>;
  }
};

export default DateCell;
